import { Schemas } from 'src/openapi/generated/types';
import { sleep } from './sleep';
import { ReservationFlowInvalidRequestError } from 'src/interfaces/reservation_flow';

// 429エラーを判定する
const isApiErrorWithTooManyRequests = (
  error: unknown,
): error is { response: { data: Schemas.APIError } } => {
  return !!(
    error &&
    typeof error === 'object' &&
    'response' in error &&
    error.response &&
    typeof error.response === 'object' &&
    'data' in error.response &&
    error.response.data &&
    typeof error.response.data === 'object' &&
    'code' in error.response.data &&
    error.response.data.code === 'too_many_requests'
  );
};

/**
 * 429: TooManyRequestsErrorの場合のみ一定回数リトライ処理するための関数
 * @param apiCall 実行するAPI呼び出し関数
 */
export const executeWithRetryForTooManyRequestsError = async <T>(
  apiCall: () => Promise<T>,
): Promise<T> => {
  const maxRetries = 3;
  const retryDelayBase = 3000; // 3秒
  let attempt = 0;
  let lastError: unknown;
  while (attempt < maxRetries) {
    try {
      await sleep(retryDelayBase * attempt);
      return await apiCall();
    } catch (error: unknown) {
      if (!isApiErrorWithTooManyRequests(error)) {
        // 429ではない場合初回からerrorにする
        throw error;
      }
      lastError = error;
      attempt += 1;
    }
  }
  throw lastError;
};

// 予約時に復旧できないエラーが発生した場合に利用する固定エラー
export const fallbackUnrecoverableError: ReservationFlowInvalidRequestError = {
  code: 'internal_server_error',
  message: 'internal_server_error',
  details: [
    {
      type: 'reservation_flow_invalid_request',
      invalid_items: [
        {
          type: 'unrecoverable_error',
          message: 'FALLBACK_UNRECOVERABLE_ERROR',
        },
      ],
    },
  ],
  error: {
    type: 'internal_server_error',
  },
};
